// The link that opens a conversation AT one message (CHT-1984). A record that is backed by a chat message (a memory fact, the answer to a
// request question) links to `/concierge/<conversationId>?message=<streamMessageId>`. The id is a plain token, never text. It is checked
// against the same pattern as the column `conversation_message_refs.stream_message_id` before it is used for a link or a search, so a
// hand-made address cannot put anything else into the page. The id is only ever compared with the ids of the loaded messages: it is never
// put into a selector or into HTML.

/** The query parameter of the address. */
export const CITED_MESSAGE_PARAM = "message";

/** The pattern of `conversation_message_refs.stream_message_id` (check `conversation_message_refs_stream_message_id_format`). */
const STREAM_MESSAGE_ID = /^[A-Za-z0-9:_.-]{1,64}$/u;

/** The id from the address, or `null` when it is missing or not a plain message id. */
export function parseCitedMessage(value: string | null): string | null {
  return value !== null && STREAM_MESSAGE_ID.test(value) ? value : null;
}

/** The address of a conversation with a message cited. A value that is not a plain message id gives the plain conversation address. */
export function citedMessageHref(conversationHref: string, streamMessageId: string): string {
  const id = parseCitedMessage(streamMessageId);
  if (id === null) return conversationHref;
  const separator = conversationHref.includes("?") ? "&" : "?";
  return `${conversationHref}${separator}${CITED_MESSAGE_PARAM}=${encodeURIComponent(id)}`;
}
